/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css } from 'aphrodite';
import './ContextualHelpListItemModalContentWrapper.scss';

import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
  contentWrapper: {
    position: 'relative',
    minHeight: 300,
  },
});

export namespace ContextualHelpListItemModalContentWrapper {
  export interface Props extends React.HTMLAttributes<HTMLDivElement> {}
}

export const ContextualHelpListItemModalContentWrapper: React.FC<ContextualHelpListItemModalContentWrapper.Props> = ({
  children,
  ...htmlProps
}) => {
  return (
    <div {...htmlProps} className={`${css(styles.contentWrapper)} ContextualHelpModal-markup`}>
      {children}
    </div>
  );
};
